import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import BootstrapInput from '../../../shared/components/OutlinedInputBox';
import { productCategories } from '../../../../constants';
import ProductPhotoUpload from './ProductPhotoUpload';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import HpTooltip from '../../../../components/shared/components/hpTooltip';

const styles = theme => ({
  root: {
    paddingLeft: '5%',
    paddingRight: '5%'
  },
  rowSection: {
    marginBottom: '30px',
    width: '100%'
  },
  urlButton: {
    height: '50px',
    width: '100px',
    color: 'black'
  },
  urlButtonSelected: {
    color: 'white'
  },
  nobutton: {
    marginLeft: '30px'
  },
  select: {
    width: '100%',
    marginTop: '0px',
    marginBottom: '0px',
    '& > *': {
      maxWidth: 500,
      width: '100%',
      margin: '0 auto'
    }
  },
  selectMenu: {
    '& .MuiPopover-paper': {
      maxHeight: 250
    }
  },
  backButton: {
    marginTop: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit,
    color: '#000000',
    paddingLeft: 50,
    paddingRight: 50
  },
  nextButton: {
    marginTop: theme.spacing.unit * 3,
    color: '#ffffff',
    paddingLeft: 50,
    paddingRight: 50
  },
  buttons: {
    display: 'flex',
    justifyContent: 'center'
  }
});

class CampaignService extends React.Component {
  constructor() {
    super();
    this.state = {
      productCategoryErrorText: '',
      submitAttempted: false
    };
  }

  handleNextButtonClick() {
    if (!this.props.productCategory) {
      this.setState({
        submitAttempted: true,
        productCategoryErrorText: 'product category is required'
      });
    } else {
      this.setState({
        submitAttempted: true,
        productCategoryErrorText: ''
      });
      this.props.nextButtonClick();
    }
  }

  render() {
    const {
      classes,
      campaignInfo,
      changeHandler,
      shippableProdHandler,
      photoUpload,
      productCategory,
      backButtonClick
    } = this.props;

    return (
      <React.Fragment>
        <div className={classes.root}>
          <Grid
            container
            direction="row"
            align="left"
            justify="center"
            spacing={4}
          >
            <Grid item container direction="column" sm={12}>
              <div>
                <Typography gutterBottom display="inline">
                  Product Name
                </Typography>
                <HpTooltip
                  styling={{
                    marginLeft: '5px',
                    marginBottom: '2px'
                  }}
                  message={
                    'Enter a name for the product/service you are marketing.'
                  }
                />
              </div>
              <TextField
                id="productName"
                name="productName"
                variant="outlined"
                multiline
                onChange={changeHandler}
              />
            </Grid>
            <Grid
              item
              container
              direction="column"
              xs={12}
              sm={6}
              style={{ width: '100%' }}
            >
              <div className={classes.rowSection}>
                <div>
                  <Typography gutterBottom align="left" display="inline">
                    Product Category
                  </Typography>
                  <HpTooltip
                    styling={{
                      marginLeft: '5px',
                      marginBottom: '2px'
                    }}
                    message={'Select the best fit for your product/service.'}
                  />
                </div>
                <TextField
                  id="productCategory"
                  name="productCategory"
                  select
                  className={classes.select}
                  SelectProps={{
                    MenuProps: {
                      className: classes.selectMenu
                    }
                  }}
                  margin="normal"
                  variant="outlined"
                  onChange={changeHandler}
                  value={productCategory}
                  error={
                    this.state.submitAttempted &&
                    this.state.productCategoryErrorText
                      ? true
                      : false
                  }
                  helperText={
                    this.state.submitAttempted
                      ? this.state.productCategoryErrorText
                      : ''
                  }
                >
                  {productCategories.map((item, i) => (
                    <MenuItem key={i} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
              <div>
                <Typography gutterBottom align="left">
                  Product Photo
                </Typography>
                <ProductPhotoUpload
                  productPhotoUrl={campaignInfo.productPhotoUrl}
                  uploadHandler={photoUpload}
                />
              </div>
            </Grid>
            <Grid item container direction="column" xs={12} sm={6}>
              <div className={classes.rowSection}>
                <div>
                  <Typography gutterBottom align="left" display="inline">
                    Product Url
                  </Typography>
                  <HpTooltip
                    styling={{
                      marginLeft: '5px',
                      marginBottom: '2px'
                    }}
                    message={
                      'Enter a url so content creators can check out your product.'
                    }
                  />
                </div>
                <TextField
                  id="productUrl"
                  name="productUrl"
                  variant="outlined"
                  fullWidth
                  value={campaignInfo.productUrl}
                  onChange={changeHandler}
                />
              </div>
              <div className={classes.rowSection}>
                <div>
                  <Typography gutterBottom align="left" display="inline">
                    Shippable Product
                  </Typography>
                  <HpTooltip
                    styling={{
                      marginLeft: '5px',
                      marginBottom: '2px'
                    }}
                    message={'Will you ship your product to content creators?'}
                  />
                </div>
                <Button
                  id="isShippableProduct"
                  name="isShippableProduct"
                  variant="contained"
                  color={campaignInfo.shippableProduct && 'primary'}
                  className={`
                    ${classes.urlButton}
                    ${campaignInfo.shippableProduct &&
                      classes.urlButtonSelected}
                  `}
                  onClick={() => shippableProdHandler(true)}
                >
                  Yes
                </Button>
                <Button
                  id="isNotShippableProduct"
                  name="isNotShippableProduct"
                  variant="contained"
                  color={!campaignInfo.shippableProduct && 'primary'}
                  className={`
                    ${classes.urlButton}
                    ${!campaignInfo.shippableProduct &&
                      classes.urlButtonSelected}
                    ${classes.nobutton}
                  `}
                  onClick={() => shippableProdHandler(false)}
                >
                  No
                </Button>
              </div>
            </Grid>

            <Grid item container direction="column" sm={12}>
              <div>
                <Typography gutterBottom display="inline">
                  Product Description
                </Typography>
                <HpTooltip
                  styling={{
                    marginLeft: '5px',
                    marginBottom: '2px'
                  }}
                  message={
                    "Enter a description for your product so the content creator will know what it's all about."
                  }
                />
              </div>
              <TextField
                id="description"
                name="description"
                variant="outlined"
                multiline
                onChange={changeHandler}
              />
            </Grid>
          </Grid>
        </div>
        <div className={classes.buttons}>
          <Button onClick={backButtonClick} className={classes.backButton}>
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleNextButtonClick.bind(this)}
            className={classes.nextButton}
          >
            Next
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

CampaignService.PropTypes = {
  campaignInfo: PropTypes.object,
  photoUpload: PropTypes.func,
  changeHandler: PropTypes.func,
  shippableProdHandler: PropTypes.func
};

export default withStyles(styles)(CampaignService);



// WEBPACK FOOTER //
// ./src/components/company/campaign/components/CampaignService.js